'use es6';

import IPEUIBackend from './IPEUIBackend';
import getEmptyImage from './getEmptyImage';
import * as NativeTypes from './NativeTypes';
export { NativeTypes, getEmptyImage };
export default function createIPEUIBackend(optionsOrManager = {}) {
  const IPEUIBackendFactory = function IPEUIBackendFactory(manager) {
    return new IPEUIBackend(manager, optionsOrManager);
  };
  if (optionsOrManager.getMonitor) {
    return IPEUIBackendFactory(optionsOrManager);
  } else {
    return IPEUIBackendFactory;
  }
}